import { useTranslation } from "react-i18next"
import { useAppDispatch } from "../../../app/hooks"
import { showModalTarotAct } from "../../tarot/domain/slice/tarot-slice"
import ReactGA from 'react-ga4';


export default function HomeSlider() {
	const dispatch = useAppDispatch()
	const {t} = useTranslation()

	const showModalTarot = () => {
		ReactGA.event({
			category: 'Tarot Slider',
			action: 'Click',
			label: 'web'
		})
		dispatch(showModalTarotAct(true))
	}

  return (
    <>
      {/* <!--Slider Start--> */}
			<div className="ast_slider_wrapper ast_index_tarot">
				<div className="ast_banner_text">
					<div className="starfield">
						<span></span>
						<span></span>
						<span></span>
						<span></span>
					</div>
					<div className="container">
						<div className="ast_bannertext_wrapper">
							<h1>{t('tarot_slider_title')}</h1>
							{/* <ul className="ast_toppadder40 ast_bottompadder50">
								<li>tarot card</li>
								<li>gemstones</li>
								<li>numerology</li>
							</ul> */}
							<button onClick={showModalTarot} className="ast_btn mt-5">{t('tarot_slider_take_read')}</button>
						</div>
					</div>	
				</div>
			</div>
			{/* <!--Slider End--> */}
    </>
  )
}